export default {"src":"/_next/static/media/5.25deeef1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};